module.exports = __webpack_public_path__ + "img/frame (281).d5f43724.jpg";